"use client";

import { CurrencySymbol } from "@repo/components";
import { useFilterOptions } from "@repo/lib/hooks/catalog";
import { useLocale } from "next-intl";
import { useEffect, useState } from "react";
import { Range } from "react-range";
const FilterPrice = ({
  min = 0,
  max = 10000,
  type = "price"
}) => {
  const [isDragging, setIsDragging] = useState(false);
  const {
    selectedValues,
    updatePriceFilter
  } = useFilterOptions();
  const [priceRange, setPriceRange] = useState([min, max]);
  const locale = useLocale();
  const lang = locale === "ar" ? true : false;
  useEffect(() => {
    // Initialize price range from selected values if available
    const priceString = selectedValues[type]?.[0] || "";
    const [minValue, maxValue] = priceString.split("-").map(Number);
    if (!isNaN(minValue) && !isNaN(maxValue)) {
      setPriceRange([minValue, maxValue]);
    } else {
      // Reset to initial min/max if filter is cleared
      setPriceRange([min, max]);
    }
  }, [selectedValues, type, min, max]);
  const handleSliderChange = values => {
    setIsDragging(true);
    setPriceRange(values);
  };
  const handleFinalPriceChange = values => {
    if (isDragging) {
      updatePriceFilter(values[0], values[1], min, max);
      setIsDragging(false);
    }
  };
  if (min === max) return;
  return <div className="px-3.5 pt-10" data-sentry-component="FilterPrice" data-sentry-source-file="FilterPrice.jsx">
      <div className="flex flex-wrap justify-center">
        <Range draggableTrack min={min} max={max} values={priceRange} onChange={handleSliderChange} onFinalChange={handleFinalPriceChange} // Apply filter on final change when user stops dragging the handles
      renderTrack={({
        props,
        children
      }) => <div {...props} onMouseDown={props.onMouseDown} onTouchStart={props.onTouchStart} className="bg-toolbar-filter-rangeBarTrack flex h-[5px] w-full rounded-full">
              <div ref={props.ref} className="bg-toolbar-filter-active absolute h-[5px]" style={{
          [lang ? "right" : "left"]: `${(priceRange[0] - min) / (max - min) * 100}%`,
          width: `${(priceRange[1] - priceRange[0]) / (max - min) * 100}%`
        }} />
              {children}
            </div>} renderThumb={({
        props,
        isDragged
      }) => <div {...props} key={props.key} className="bg-toolbar-filter-active flex size-[26px] justify-center rounded-full" style={{
        ...props.style,
        alignItems: "center"
        //boxShadow: "0px 2px 6px #AAA",
      }}>
              {/*
                <div
                className={cx("h-[10px] w-[3px]", {
                  "bg-brown": isDragged,
                  "bg-[#CCC]": !isDragged,
                })}
               />
                */}
            </div>} rtl={lang} data-sentry-element="Range" data-sentry-source-file="FilterPrice.jsx" />
      </div>

      <div className="mt-8 flex justify-center space-x-3 text-center">
        <span className="inline-block w-[70px] text-center">
          <CurrencySymbol value={priceRange[0].toFixed(1)} variant="smallSpecial" data-sentry-element="CurrencySymbol" data-sentry-source-file="FilterPrice.jsx" />
        </span>
        <span>-</span>
        <span className="inline-block w-[70px] text-center">
          <CurrencySymbol value={priceRange[1].toFixed(1)} variant="smallSpecial" data-sentry-element="CurrencySymbol" data-sentry-source-file="FilterPrice.jsx" />
        </span>
      </div>
    </div>;
};
export default FilterPrice;